import { RelodeApiError, ValidationError } from "@relode/core";
import { TeamResponse } from "../../../shared/backend/controllers/teams";
import { JobManagerContact, TagMatch } from "../../../shared/types";
import { AddJobStepsEnum } from "../types";
import { ErrorType } from "./errorType";

export interface AddJobState {
    ui: {
        errors: {
            type: string;
            message?: string;
            apiError?: RelodeApiError;
        }[];
        error?: {
            type: ErrorType;
            message?: string;
            apiError?: RelodeApiError;
            currentStep?: string;
        };
        stepOneValidationErrors?: ValidationError[];
        stepTwoValidationErrors?: ValidationError[];
        isStepValid: { one: boolean; two: boolean };
        isLoading: boolean;
        activeStepId: string;
        isJobMovedToRequested: boolean;
        showOrderConfirmationStep: boolean;
    };
    data: {
        jobId: number;
        teams: TeamResponse[];
        tags: TagMatch[];
        jobManagerDetails?: JobManagerContact;
    };
}

export const initialAddJobState: AddJobState = {
    ui: {
        isLoading: false,
        activeStepId: AddJobStepsEnum.Step1,
        error: undefined,
        errors: [],
        isStepValid: { one: true, two: true },
        isJobMovedToRequested: false,
        showOrderConfirmationStep: false,
    },
    data: {
        jobId: undefined,
        teams: undefined,
        tags: undefined,
    },
};
